import { Link } from 'react-router-dom';

export default function SEOSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-4xl mx-auto">
        {/* Section label */}
        <div className="text-center mb-12">
          <span className="text-xs font-semibold text-foreground-400 uppercase tracking-[0.2em]">Руководства</span>
        </div>

        {/* SEO content block */}
        <div className="relative bg-background-50 rounded-3xl p-8 md:p-12 border border-background-200">
          {/* Article image */}
          <div className="w-full rounded-2xl overflow-hidden mb-8 h-52 md:h-64">
            <img
              src="https://readdy.ai/api/search-image?query=Organized%20modern%20desk%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%20alongside%20printed%20product%20catalogs%20and%20sourcing%20documents%20warm%20natural%20lighting%20from%20window%20clean%20minimal%20aesthetic%20with%20neutral%20beige%20tones%20professional%20editorial%20photography%20style&width=800&height=500&seq=seo-featured-main-v2&orientation=landscape"
              alt="YOYBUY Spreadsheet руководство"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>

          {/* Rating badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-foreground-900 rounded-full mb-8">
            <i className="ri-star-fill text-accent-400 text-sm"></i>
            <span className="text-xs font-semibold text-background-50">4.9 / 5.0</span>
          </div>

          {/* Article preview */}
          <article className="prose-custom">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6 leading-tight">
              YOYBUY Spreadsheet: полное руководство по закупкам из Китая в 2026 году
            </h3>

            <div className="flex flex-col gap-4 text-foreground-600 leading-relaxed text-sm md:text-base">
              <p>
                <strong className="text-foreground-900">YOYBUY Spreadsheet</strong> — это инновационная система
                управления закупками, которая объединяет данные о товарах, поставщиках и логистике
                в одной удобной таблице. В отличие от традиционных методов поиска товаров на
                Taobao, 1688 и других китайских площадках, наш <strong className="text-foreground-900">spreadsheet</strong> подход
                позволяет систематизировать процесс и принимать обоснованные решения.
              </p>
              <p>
                Система поддерживает три ключевые платформы: <strong className="text-foreground-900">YOYBUY</strong> как
                основную, <strong className="text-foreground-900">Kakobuy</strong> как быструю альтернативу
                и <strong className="text-foreground-900">Superbuy</strong> для профессиональных закупщиков.
                Каждая платформа имеет свою таблицу с уникальными данными, но все они
                интегрированы в единую экосистему <strong className="text-foreground-900">YOYBUY Spreadsheet</strong>.
              </p>
              <p>
                Что делает <strong className="text-foreground-900">yoybuy spreadsheet</strong> особенным?
                Прежде всего — это структурированный подход. Вместо хаотичного поиска вы
                получаете готовую таблицу с категориями, ценами, рейтингами поставщиков и
                расчётной маржой. Это особенно важно для тех, кто занимается дропшиппингом
                или планирует открыть свой интернет-магазин с товарами из Китая.
              </p>
            </div>
          </article>

          {/* Article CTA */}
          <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
            <Link
              to="/article/yoybuy-spreadsheet-polnoe-rukovodstvo"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="px-6 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              Читать полную статью
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 border border-background-300 text-foreground-700 rounded-full text-sm font-medium hover:border-foreground-400 hover:text-foreground-900 transition-all whitespace-nowrap cursor-pointer"
            >
              Открыть YOYBUY Sheet
            </a>
          </div>
        </div>

        {/* Keywords hint for SEO */}
        <div className="mt-8 flex flex-wrap gap-2 justify-center">
          {['yoybuy spreadsheet', 'kakobuy spreadsheet', 'superbuy spreadsheet', 'china sourcing', 'таблица закупок'].map((kw) => (
            <span key={kw} className="px-3 py-1.5 bg-background-200/60 text-foreground-500 text-xs rounded-full whitespace-nowrap">
              {kw}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}